import { CommandCenterScreen } from '../features/console';

export function DashboardPage() {
  return <CommandCenterScreen />;
}
